import React, { useState, useEffect } from "react";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdOutlineSettings } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./Homeleft.css";

const Homeleft = () => {
  const [selectedTab, setSelectedTab] = useState("cases");

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <div className="homeleft-wrapper">
      <div className="homeleft-inner">
        <div className="tabs">
          <div
            className={`tab-item ${selectedTab === "cases" ? "active" : ""}`}
            onClick={() => handleTabClick("cases")}
          >
            Cases
          </div>
        {/* Finances Tab - Completely Disabled */}
<div
  className="tab-item"
  style={{
    backgroundColor: "#f0f0f0",
    color: "#999",
    borderColor: "#ddd",
    cursor: "not-allowed",
    opacity: 0.5,
    pointerEvents: "none",
    userSelect: "none",
  }}
  aria-disabled="true"
  title="Finances is currently disabled"
>
  Finances
</div>
        </div>
        {selectedTab === "cases" && (
          // ✅ overflow hidden removed so the settings dropdown is not clipped
          <div className="cases-content" style={{ overflow: "visible" }}>
            <CaseData />
          </div>
        )}
       {false && selectedTab === "finances" && (
          <div className="finances-content">
            <div className="finances-grid">
              <div className="finance-card">
                <p className="finance-card-title">Money Owed</p>
                <p className="finance-card-value">₨ 25,000</p>
              </div>
              <div className="finance-card">
                <p className="finance-card-title">Declining Customers</p>
                <p className="finance-card-value">12</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// =================================================================
// CaseData – fetches PRE-COMPUTED counts from the backend
// =================================================================
const CaseData = () => {
  const navigate = useNavigate();

  const [labId, setLabId] = useState(null);
  const [userType, setUserType] = useState(null);
  const [authLoaded, setAuthLoaded] = useState(false);
  const [accountIds, setAccountIds] = useState([]);
  const [labAccountsLoaded, setLabAccountsLoaded] = useState(false);

  const [caseCounts, setCaseCounts] = useState({
    arriving: { Today: 0, "This Month": 0, "This Week": 0, Forever: 0 },
    shipping: {
      Today: 0,
      Tomorrow: 0,
      "This Month": 0,
      "This Week": 0,
      Forever: 0,
      Past: 0,
    },
    onHold: { Today: 0, "This Month": 0, "This Week": 0, Forever: 0 },
    openTryIn: { Today: 0, "This Month": 0, "This Week": 0, Forever: 0 },
    pickups: { Today: 0, "This Month": 0, "This Week": 0 },
    deliveries: { Today: 0, "This Month": 0, "This Week": 0 },
    newAccounts: {
      "Today First Case": 0,
      "Today First Invoice": 0,
      "Today Account Created": 0,
      "This Month": 0,
    },
    preInvoiced: {
      "Pre-invoiced but not closed Pre-invoiced cases": 0,
      "Pre-invoiced and closed Pre-invoiced cases": 0,
      "This Month": 0,
    },
  });

  const [selectedOptions, setSelectedOptions] = useState({
    arriving: "Today",
    shipping: "Today",
    onHold: "This Month",
    openTryIn: "This Month",
    pickups: "Today",
    deliveries: "Today",
    newAccounts: "Today First Case",
    preInvoiced: "Pre-invoiced but not closed Pre-invoiced cases",
  });

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [todayDeliveryCases, setTodayDeliveryCases] = useState([]);

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleArrivingCasesClick = () => {
    const selectedOption = selectedOptions.arriving;
    const filterType = selectedOption.toLowerCase().replace(" ", "");
    navigate(`/casesArrive?filter=${filterType}&labId=${labId || ''}&userType=${userType || ''}`);
  };

  // ✅ explicit on-hold filter + multi-space safe slug
  const handleOnHoldCasesClick = () => {
    const selectedOption = selectedOptions.onHold;
    const filterType = selectedOption.toLowerCase().replace(/\s+/g, "");
    navigate(
      `/casesOnHold?filter=${filterType}&labId=${labId || ''}&userType=${userType || ''}&status=on%20hold`
    );
  };

  // ---- Auth (unchanged) ----
  useEffect(() => {
    let storedLabId = localStorage.getItem('userLabId');
    let storedUserType = localStorage.getItem('userType');

    if (!storedLabId) {
      storedLabId = sessionStorage.getItem('userLabId');
    }
    if (!storedUserType) {
      storedUserType = sessionStorage.getItem('userType');
    }

    const userDataStr = localStorage.getItem('userData') || sessionStorage.getItem('userData');
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        if (!storedLabId && userData.labId) {
          storedLabId = userData.labId;
        }
        if (!storedUserType && userData.userType) {
          storedUserType = userData.userType;
        }
      } catch (e) {}
    }

    if (storedLabId) {
      setLabId(storedLabId);
    }
    if (storedUserType) {
      setUserType(storedUserType);
    } else if (storedLabId) {
      setUserType('lab');
    } else {
      setUserType('admin');
    }
    setAuthLoaded(true);
  }, []);

  // ---- Fetch ONLY accountIds for a lab (small payload) ----
  useEffect(() => {
    if (!authLoaded) return;

    if (userType !== 'lab' || !labId) {
      setLabAccountsLoaded(true);
      return;
    }

    const fetchLabAccountIds = async () => {
      try {
        const response = await axios.get(
          `https://hms.backend.hiragroupcloud.com/api/account/lab-accounts/${labId}`
        );
        if (response.data && response.data.success) {
          const ids = (response.data.data || [])
            .map(acc => acc.accountId)
            .filter(Boolean);
          setAccountIds(ids);
        } else {
          setAccountIds([]);
        }
      } catch (error) {
        setAccountIds([]);
      } finally {
        setLabAccountsLoaded(true);
      }
    };
    fetchLabAccountIds();
  }, [authLoaded, userType, labId]);

  // ---- Fetch pre-computed dashboard counts from backend ----
  // ✅ FIX: also send userLabId so backend can match cases
  //    whose account_holder is NOT in the lab's account list.
  useEffect(() => {
    if (!authLoaded || !labAccountsLoaded) return;

    const fetchDashboardCounts = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams();
        params.set('userType', userType || 'admin');
        if (userType === 'lab') {
          params.set('accountIds', accountIds.join(','));
          // ✅ FIX: pass immutable userLabId as well
          if (labId) {
            params.set('userLabId', String(labId).trim());
          }
        }

        const response = await axios.get(
          `https://hms.backend.hiragroupcloud.com/api/cases/dashboard-counts?${params.toString()}`
        );

        if (response.data && response.data.success) {
          setCaseCounts(response.data.data);
          setTodayDeliveryCases(response.data.todayDeliveryCases || []);
        } else {
          setError('Failed to load data. Please try again.');
        }
      } catch (error) {
        setError("Failed to load data. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchDashboardCounts();
  }, [authLoaded, labAccountsLoaded, userType, accountIds, labId]);

  const caseData = [
    {
      title: "Cases Arriving",
      defaultCount: 0,
      counts: caseCounts.arriving,
      onClick: handleArrivingCasesClick,
      showSettings: true,
      showCurrency: false,
      dropdownOptions: ["Today", "This Month", "This Week", "Forever"],
      category: "arriving",
      currencyValue: "",
    },
    {
      title: "Cases Shipping",
      defaultCount: 0,
      counts: caseCounts.shipping,
      onClick: () => {
        navigate(`/caseship?labId=${labId || ''}&userType=${userType || ''}`);
      },
      showSettings: true,
      showCurrency: false,
      dropdownOptions: [
        "Today",
        "Tomorrow",
        "This Month",
        "This Week",
        "Forever",
        "Past",
      ],
      category: "shipping",
      currencyValue: "",
    },
    {
      title: "Cases On Hold",
      defaultCount: 0,
      counts: caseCounts.onHold,
      onClick: handleOnHoldCasesClick,
      showSettings: true,
      showCurrency: false,
      dropdownOptions: ["Today", "This Month", "This Week", "Forever"],
      category: "onHold",
      currencyValue: "",
    },
    {
      title: "Open Try-in Cases",
      defaultCount: 0,
      counts: caseCounts.openTryIn,
      onClick: () => {
        navigate(`/openTryInCases?labId=${labId || ''}&userType=${userType || ''}`);
      },
      showSettings: true,
      showCurrency: false,
      dropdownOptions: ["Today", "This Month", "This Week", "Forever"],
      category: "openTryIn",
      currencyValue: "",
    },
    {
      title: "New Accounts",
      defaultCount: 0,
      counts: caseCounts.newAccounts,
      showSettings: true,
      showCurrency: false,
      dropdownOptions: [
        "Today First Case",
        "Today First Invoice",
        "Today Account Created",
        "This Month",
      ],
      category: "newAccounts",
    },
    {
      title: "Pickups",
      defaultCount: 0,
      counts: caseCounts.pickups,
      onClick: () => {
        navigate(`/NewCasePickup?labId=${labId || ''}&userType=${userType || ''}`);
      },
      showSettings: true,
      showCurrency: false,
      dropdownOptions: ["Today", "This Month", "This Week"],
      category: "pickups",
    },
    {
      title: "Deliveries",
      defaultCount: 0,
      counts: caseCounts.deliveries,
      onClick: () => {
        const today = new Date();
        const thisMonthStart = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        );
        const thisMonthEnd = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        const thisWeekStart = new Date(today);
        thisWeekStart.setDate(
          today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1)
        );
        const thisWeekEnd = new Date(thisWeekStart);
        thisWeekEnd.setDate(thisWeekStart.getDate() + 6);
        let dateRange = {};
        if (selectedOptions.deliveries === "Today") {
          dateRange = {
            startDate: formatDate(today),
            endDate: formatDate(today),
          };
        } else if (selectedOptions.deliveries === "This Month") {
          dateRange = {
            startDate: formatDate(thisMonthStart),
            endDate: formatDate(thisMonthEnd),
          };
        } else if (selectedOptions.deliveries === "This Week") {
          dateRange = {
            startDate: formatDate(thisWeekStart),
            endDate: formatDate(thisWeekEnd),
          };
        }

        navigate("/addshipping", {
          state: {
            todayDeliveryCases,
            selectedPeriod: selectedOptions.deliveries,
            dateRange,
            labId,
            userType
          },
        });
      },
      showSettings: true,
      showCurrency: false,
      dropdownOptions: ["Today", "This Month", "This Week"],
      category: "deliveries",
    },
    {
      title: "Pre-invoiced Cases",
      defaultCount: 0,
      counts: caseCounts.preInvoiced,
      onClick: () => {
        navigate(`/OpenCasesHold?labId=${labId || ''}&userType=${userType || ''}`);
      },
      showSettings: true,
      showCurrency: false,
      dropdownOptions: [
        "Pre-invoiced but not closed Pre-invoiced cases",
        "Pre-invoiced and closed Pre-invoiced cases",
        "This Month",
      ],
      category: "preInvoiced",
    },
  ];

  if (!authLoaded || !labAccountsLoaded) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        Loading cases...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
        {error}
      </div>
    );
  }

  return (
    <div className="case-data-grid">
      {caseData.map((data, index) => (
        <CardWithSettings
          key={index}
          data={data}
          selectedOption={selectedOptions[data.category]}
          onSelect={(option) =>
            setSelectedOptions((prev) => {
              return { ...prev, [data.category]: option };
            })
          }
        />
      ))}
    </div>
  );
};

// =================================================================
// CardWithSettings – settings dropdown now opens INSIDE the card
// (same behaviour as the second code), selected option highlighted
// =================================================================
const CardWithSettings = ({ data, selectedOption, onSelect }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleSettingsClick = (e) => {
    e.stopPropagation();
    setDropdownVisible((prev) => !prev);
  };

  const handleDropdownSelect = (option) => {
    onSelect(option);
    setDropdownVisible(false);
  };

  const getCountValue = () => {
    if (!data.counts || !selectedOption) {
      return data.defaultCount;
    }
    const count =
      data.counts[selectedOption] !== undefined
        ? data.counts[selectedOption]
        : data.defaultCount;

    return count;
  };

  return (
    <div className="card-item">
      <div className="card-title">
        {/* ✅ settings icon now sits on the right side of the title text */}
        <div className="card-title-row">
          <p>{data.title}</p>
          {data.showSettings && data.dropdownOptions && (
            <MdOutlineSettings
              className="card-settings-icon"
              onClick={handleSettingsClick}
            />
          )}
        </div>
        {selectedOption && (
          <span className="card-option-label">
            ({selectedOption})
          </span>
        )}
      </div>
      <div
        className="card-count-container"
        onClick={data.onClick}
      >
        <span className="card-count">
          {getCountValue()}
        </span>
        {data.showCurrency && data.currencyValue && (
          <span className="card-currency">
            {data.currencyValue}
          </span>
        )}
      </div>
      {dropdownVisible && data.dropdownOptions && (
        <div
          className="card-dropdown-menu"
          onClick={(e) => e.stopPropagation()}
        >
          {data.dropdownOptions.map((option, index) => (
            <div
              key={index}
              className={`card-dropdown-option ${selectedOption === option ? "selected" : ""}`}
              onClick={() => handleDropdownSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Homeleft;